import { ComponentStyleConfig } from '@chakra-ui/react'

export const Drawer: ComponentStyleConfig = {
    parts: ['dialog', 'header', 'body'],
    sizes: {
        xl: {
            dialog: {
                maxW: '888px',
            },
        },
    },
    variants: {
        dashboardMenu: {
            dialog: {
                maxW: '182px',
            },
        },
        bankingDetails: {
            dialog: {
                maxW: '531px',
            },
        },
    },
}
